export const standard = {
  tension: 310,
  friction: 25,
  clamp: true
}

export const wobble = {
  tension: 250,
  friction: 25
}

export const slowWobble = {
  tension: 175,
  friction: 20
}

export const stiff = {
  tension: 215,
  friction: 40
}

export const fast = {
  tension: 300,
  friction: 40
}
